import React from "react";

export function InputMessage(array, selectedValue) {
    if (array && Array.isArray(array)) {
        let filterValue = null;
        if (selectedValue !== '' && selectedValue !== null && selectedValue !== undefined) {
            filterValue = array.find(item => item && item.id === selectedValue);
        }

        if (filterValue && filterValue.message) {
            return (
                <div className="text-green d-flex align-items-center mb-3">
                    <i className='bx bx-info-circle fs-5 pe-2'/>{filterValue.message}
                </div>
            );
        }
    }
    return "";
}